import React from 'react';

const SkeletonCard = () => {
  return (
    <div className="card animate-skeleton-pulse">
      {/* Image skeleton */}
      <div className="relative h-52 bg-gray-200 rounded-t-2xl overflow-hidden">
        <div className="absolute inset-0 bg-gradient-to-r from-transparent via-white/30 to-transparent animate-shimmer" />
      </div>

      {/* Content skeleton */}
      <div className="p-5 space-y-3">
        {/* Title */}
        <div className="h-5 bg-gray-200 rounded-lg w-3/4" />
        
        {/* Location */}
        <div className="flex items-center space-x-2">
          <div className="w-4 h-4 bg-gray-200 rounded-full" />
          <div className="h-4 bg-gray-200 rounded w-1/2" />
        </div>

        {/* Description lines */}
        <div className="space-y-2 pt-1">
          <div className="h-3 bg-gray-200 rounded w-full" />
          <div className="h-3 bg-gray-200 rounded w-5/6" />
        </div>

        {/* Divider + bottom row */}
        <div className="border-t border-gray-100 pt-4">
          <div className="flex items-center justify-between">
            <div className="h-4 bg-gray-200 rounded w-24" />
            <div className="h-4 bg-gray-200 rounded w-5" />
          </div>
        </div>
      </div>
    </div>
  );
};

export default SkeletonCard;